export default "__VITE_ASSET__3oyL5$FC__"